import axios from 'axios'
import { useLoadingStore } from '@/store/loading'
import { useMainStore } from '@/store'
import { errorHandler } from '@/utils/errorHandler'
import { getLang } from "@/i18n"
import { showFailToast } from 'vant';
import router from '@/router'


const service = axios.create({
    // baseURL: 'http://192.168.8.199:3401/api',
    baseURL: import.meta.env.VITE_API_BASE,
    timeout: 10000,
})

// 请求拦截
service.interceptors.request.use(config => {

    if (!config.closeLoading) {
        const loadingStore = useLoadingStore()
        loadingStore.show()
    }
    // console.log(config);

    const { isToken = true } = config
    if (isToken) {
        const mainStore = useMainStore()
        const token = mainStore.token || localStorage.getItem('token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
    }


    // --------- 添加语言字段 ---------
    const lang = getLang();

    // GET 或 DELETE：放到 params
    if (config.method === 'get' || config.method === 'delete') {
        config.params = {
            ...(config.params || {}),
            lang
        };
    } else {
        // POST、PUT 等：放到 data
        if (config.data instanceof FormData) {
            // FormData 特殊处理
            // config.data.append('lang', lang);
        } else {
            config.data = {
                ...(config.data || {}),
                lang
            };
        }
    }
    return config
}, error => {
    if (!error.config.closeLoading) {
        const loadingStore = useLoadingStore()
        loadingStore.hide()
    }
    return Promise.reject(error)
})

// 响应拦截
service.interceptors.response.use(
    async response => {
        if (!response.config.closeLoading) {
            const loadingStore = useLoadingStore()
            await loadingStore.hide()
            // console.log(1);
        }

        if (response.data.code == 401) {
            const mainStore = useMainStore()
            mainStore.removeStore()
            localStorage.removeItem('custom-main-key-store')
            router.push('/')
            return
        }

        if (response.data.code != 200 && !response.config.closeErrorToast) {
            showFailToast(response.data.message);
        }
        return response.data
    },
    error => {
        if (error.status == 401) {
            const mainStore = useMainStore()
            mainStore.removeStore()
            localStorage.removeItem('custom-main-key-store')
            router.push('/')
        }
        if (!error.config.closeLoading) {
            const loadingStore = useLoadingStore()
            loadingStore.hide()
        }
        if (!error.config.closeErrorToast) {
            errorHandler(error)
        }
        return Promise.reject(error)
    }
)

export default service
